import React from "react";

function ChargeableWeight(VolumeWeight, actualWeight) {
    if(parseFloat(VolumeWeight) <= parseFloat(actualWeight))
        VolumeWeight = actualWeight;
    return VolumeWeight;
};
export default ChargeableWeight;
